import ColumnsBlockView from '../../../../components/ColumnsBlock/ColumnsBlockView';

export default ColumnsBlockView;
